const HIDE_OD_BANNER = 'NS_PORTAL_HIDE_OD_BANNER';

export const saveHiddenOdBookingId = (bookingId) => localStorage.setItem(HIDE_OD_BANNER, bookingId);

export const getHiddenOdBookingId = () => localStorage.getItem(HIDE_OD_BANNER);
